/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `reportDownloadRules` for the Caintra Connect frontend.
 * @module utils/reportDownloadRules
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
/**
 * Determines whether the download button should be enabled for a report type.
 * @param {number|undefined} reportValue - Selected report option value
 * @param {Object} filters - Current report filter state
 * @returns {boolean}
 */
export const isReportDownloadEnabled = (reportValue, filters) => {
  if (reportValue === 1) {
    return !!(
      filters.selectedMemberCompany ||
      filters.startDate ||
      filters.endDate
    );
  }
  if (reportValue === 2) {
    return !!(
      filters.selectedEvent || filters.selectedBuyerCompanies?.length > 0
    );
  }
  if (reportValue === 3) {
    return !!filters.selectedB2bEvent;
  }
  if (reportValue === 4 || reportValue === 5) {
    return !!(filters.selectedYear && filters.selectedEvent);
  }
  if (reportValue === 6 || reportValue === 7) {
    return !!(filters.selectedYear && filters.selectedEvent);
  }
  if (reportValue === 8 || reportValue === 10) {
    return !!(filters.selectedYear && filters.selectedEventTypes?.length > 0);
  }
  if (reportValue === 9) {
    return !!(filters.selectedYear && filters.selectedEvent);
  }
  if (reportValue === 11) {
    return true;
  }
  if (reportValue === 12) {
    return !!(filters.selectedYear && filters.selectedB2bEvent);
  }
  if (reportValue === 13) {
    return !!(filters.selectedYear && filters.selectedEvent);
  }
  return false;
};
